var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "bio-material-step-summary"
    }
  }, [_c('section', {
    staticClass: "summary-message"
  }, [!_vm.hasError && !_vm.materialRemoved ? _c('div', {
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": _vm.checkIconSrc,
      "alt": "green check"
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._v("Added " + _vm._s(_vm.materialLabel) + " to " + _vm._s(_vm.groupName))])]) : _vm._e(), _vm._v(" "), !_vm.hasError && _vm.materialRemoved ? _c('div', {
    staticClass: "success-info"
  }, [_c('img', {
    attrs: {
      "src": _vm.infoSrc,
      "alt": "info icon"
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._v("\n        Removed " + _vm._s(_vm.materialLabel) + " from " + _vm._s(_vm.groupName) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm.hasError ? _c('div', {
    staticClass: "alert-group"
  }, [_c('div', {
    staticClass: "alert"
  }, [_c('img', {
    attrs: {
      "src": _vm.alertSrc,
      "alt": "alert icon"
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._v("Unable to add material.")])]), _vm._v(" "), _c('ErrorStateLinks')], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "summary-actions"
  }, [_c('VButton', {
    staticClass: "primary",
    on: {
      "click": _vm.addAnother
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.plusSignSrc,
      "alt": "plus"
    }
  }), _vm._v("\n      Add Another\n    ")]), _vm._v(" "), _vm.isInBioWizard ? _c('VButton', {
    staticClass: "primary ghost",
    on: {
      "click": _vm.emitDone
    }
  }, [_vm._v("\n      Done\n    ")]) : _c('VButton', {
    staticClass: "primary ghost",
    on: {
      "click": _vm.openAssociateMaterialsLink
    }
  }, [_vm._v("\n      Associate Materials\n    ")])], 1), _vm._v(" "), _vm.showBackButton ? _c('div', [_c('a', {
    attrs: {
      "data-testid": "back",
      "href": ""
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.backToMaterialSelect.apply(null, arguments);
      }
    }
  }, [_vm._v("Back")])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }